export default ['all', 'prodotti', 'eventi', 'innovazioni', 'premi']
